<script setup lang="ts">
import { RouterLink } from 'vue-router'
import libraryLogo from '@/assets/resource-library-logo.webp'
import libraryMark from '@/assets/resource-library-mark.png'
import { siteConfig } from './site-config'
</script>

<template>
  <RouterLink to="/" class="app-brand" :aria-label="`${siteConfig.name}首页`">
    <picture class="app-brand__picture">
      <source media="(max-width: 767px)" :srcset="libraryMark" />
      <img
        :src="libraryLogo"
        class="app-brand__logo"
        :alt="siteConfig.name"
        :title="siteConfig.name"
        width="1800"
        height="198"
      />
    </picture>
  </RouterLink>
</template>

<style scoped>
.app-brand { display: inline-flex; align-items: center; min-width: 0; max-width: 100%; padding-block: 6px; }
.app-brand__picture { display: block; min-width: 0; max-width: 100%; }
.app-brand__logo { display: block; width: 360px; max-width: 100%; height: auto; object-fit: contain; }
@media (max-width: 1100px) {
  .app-brand__logo { width: 260px; }
}
@media (max-width: 767px) {
  .app-brand__logo { width: 40px; height: 40px; }
}
</style>
